import {useState} from "react";
import {HeaderNavProps} from "@/components/header/common/types";

interface UseDesktopNavbarProps {
  headerNavProps: HeaderNavProps[];
}

const useDesktopNavbar = ({
  headerNavProps
}: UseDesktopNavbarProps) => {
  const defaultSecondaryNavItems = headerNavProps[0].fields.subNavList ?? [];
  const defaultTertiaryHeaderLabel = defaultSecondaryNavItems[0].fields.title;
  const defaultTertiaryNavItems = defaultSecondaryNavItems[0].fields.subNavList ?? [];

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentPrimaryNavItem, setCurrentPrimaryNavItem] = useState("");
  const [tertiaryHeaderLearnMoreUrl, setTertiaryHeaderLearnMoreUrl] = useState<string>("");
  const [tertiaryHeaderViewAllDestinationsUrl, setTertiaryHeaderViewAllDestinationsUrl] = useState<string>("");
  const [tertiaryHeaderLabel, setTertiaryHeaderLabel] = useState<string>(defaultTertiaryHeaderLabel);
  const [secondaryNavItems, setSecondaryNavItems] = useState<HeaderNavProps[]>(defaultSecondaryNavItems);
  const [tertiaryNavItems, setTertiaryNavItems] = useState<HeaderNavProps[]>(defaultTertiaryNavItems);

  const handleCloseDrawer = () => {
    if (!drawerOpen) return;
    setCurrentPrimaryNavItem("");
    setDrawerOpen(false);
  };

  const handleToggleDrawer = (d: HeaderNavProps) => {
    const secondary = d.fields.subNavList ?? [];
    const hasSubNav = secondary?.length;

    if (!hasSubNav) return;

    setTertiaryHeaderLabel("");
    setTertiaryNavItems(new Array<HeaderNavProps>());
    if (d.sys.id === currentPrimaryNavItem) {
      setCurrentPrimaryNavItem("");
      setDrawerOpen(false);
      return;
    }

    setCurrentPrimaryNavItem(d.sys.id);
    setSecondaryNavItems(secondary);
    setTertiaryHeaderLabel(secondary[0].fields.title);
    setTertiaryHeaderLearnMoreUrl(secondary[0].fields.learnMoreUrl);
    setTertiaryHeaderViewAllDestinationsUrl(secondary[0].fields.viewAllDestinationsUrl);
    setTertiaryNavItems(secondary[0].fields.subNavList ?? []);
    setDrawerOpen(true);
  };

  return {
    handleCloseDrawer,
    handleToggleDrawer,
    drawerOpen,
    currentPrimaryNavItem,
    tertiaryHeaderLearnMoreUrl,
    tertiaryHeaderViewAllDestinationsUrl,
    tertiaryHeaderLabel,
    secondaryNavItems,
    tertiaryNavItems,
    setTertiaryNavItems,
    setTertiaryHeaderLabel,
    setTertiaryHeaderLearnMoreUrl,
    setTertiaryHeaderViewAllDestinationsUrl
  };
};

export default useDesktopNavbar;